// extracted by mini-css-extract-plugin
export default {"container":"UploadConsentLogsDialog_container__jyVum","cell":"UploadConsentLogsDialog_cell__1W6nz"};